import * as B from '@blueprintjs/core';
import React from 'react';

import colors from 'app/styles/colors.json';

import cs from './ContractHistory.module.scss';

const LIST_PRICE_NOTE =
  'Acres × price per acre. Doesn’t include service fees, order minimums, tax, or prepaid credit.';

/**
 * A cost column's header, noting that it's the scenes' list price rather than what an invoice charged.
 */
const ListPriceHeader: React.FC<{label: string}> = ({label}) => (
  <div className={cs.listPriceHeader}>
    <div>{label}</div>
    <B.Tooltip popoverClassName={cs.popover} className={cs.listPriceInfo} content={LIST_PRICE_NOTE}>
      <B.Icon
        className={cs.listPriceInfoIcon}
        icon="info-sign"
        color={colors.darkestGray}
        size={12}
        title={LIST_PRICE_NOTE}
      />
    </B.Tooltip>
  </div>
);

export default ListPriceHeader;
